import * as React from 'react';
export default class ToolbarLine extends React.Component {
    render() {
        return <div>{this.props.children}</div>;
    }
}



// WEBPACK FOOTER //
// ./ext/editor-core/src/Toolbar/ToolbarLine.tsx